export default {
  header: 'Download the entire press kit',
  cta: 'Download',
  url:
    'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/cta_file-downloads/NW_presskit_all_2020-v2.zip',
};
